import { render, staticRenderFns } from "./qrColors.vue?vue&type=template&id=d0a68868&scoped=true"
import script from "./qrColors.vue?vue&type=script&lang=js"
export * from "./qrColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a68868",
  null
  
)

export default component.exports